import { motion } from "framer-motion";
import { trackEvent } from "@/lib/analytics";
import SectionHeading from "./SectionHeading";
import { useTr } from "@/i18n";

export default function VideoSection() {
  const tr = useTr();
  return (
    <section id="video" className="py-24 bg-[#080808]">
      <div className="max-w-4xl mx-auto px-6">
        <SectionHeading
          eyebrow={tr("video.eyebrow", "Dal Vivo")}
          title={tr("video.title", "Guarda la Festa")}
          accent={tr("video.accent", "Niente montaggi pubblicitari: questa è una serata vera, ripresa dal vivo.")}
          testid="video-heading"
        />
        <motion.div
          data-testid="video-frame"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="gold-frame rounded-2xl bg-[#111111] p-2.5 sm:p-3"
        >
          <video
            data-testid="event-video"
            src="/assets/video/festa-dj-magix-live.mp4"
            poster="/assets/locale-festa-luci-sera-1200.webp"
            controls
            playsInline
            preload="none"
            onPlay={() => trackEvent("video_play", { video: "festa-live" })}
            className="w-full rounded-xl aspect-video object-cover bg-black"
          >
            {tr("video.fallback", "Il tuo browser non supporta il video.")}
          </video>
        </motion.div>
      </div>
    </section>
  );
}
